<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="currentSociety.account"
          :rules="[rules.required]"
          :label="$t('akito.account-name')"
          :append-icon="iconAvailable"
          dense
          :background-color="colorAvailable"
          @change="checkName()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="currentSociety.login"
          :rules="[rules.required]"
          :label="$t('profile.sections.user.login')"
          dense
        />
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col cols="9">
            <v-text-field
              v-model="currentSociety.password"
              :rules="[rules.required, rules.min]"
              :label="$t('profile.sections.user.password')"
              counter
              dense
              @click:append="show = !show"
            />
          </v-col>
          <v-col cols="3">
            <v-btn
              icon
              @click="randomPass()"
            >
              <v-icon>mdi-autorenew</v-icon>
            </v-btn>
            <v-btn
              icon
              @click="copy()"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="currentSociety.name"
          :rules="[rules.required]"
          :label="$t('profile.sections.common.name')"
          dense
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="currentSociety.firstname"
          :rules="[rules.required]"
          :label="$t('profile.sections.user.firstname')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="currentSociety.phone"
          :label="$t('profile.sections.user.phone')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          color="success"
          class="mr-4"
          :disabled="
            currentSociety.login.length < 6 || currentSociety.password.length < 8 || !nameAvailable || disableButton
          "
          @click="createSociety()"
        >
          <v-icon class="mr-2">mdi-content-save-outline</v-icon>
          {{ $t("akito.create") }}
        </v-btn>
        <v-btn
          :disabled="currentSociety.account.length < 1"
          color="warning"
          @click="autoComplete()"
        >
          <v-icon class="mr-2">mdi-auto-fix</v-icon>
          {{ $t("akito.auto-complete") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";

export default {
  data() {
    return {
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      show: false,
      currentSociety: {
        account: "",
        login: "",
        password: "",
        name: "",
        firstname: "",
        phone: "",
        access: {},
      },
      characters: "a-z,A-Z,0-9",
      size: 8,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        min: (v) => v.length >= 8 || this.$t("field.min-8"),
      },
      disableButton: false,
      nameAvailable: true,
    };
  },
  computed: {
    iconAvailable() {
      if (this.nameAvailable) {
        return "mdi-check-circle";
      } else {
        return "mdi-close-circle";
      }
    },
    colorAvailable() {
      if (this.nameAvailable) {
        return "";
      } else {
        return "error";
      }
    },
  },
  created() {
    //
  },
  methods: {
    checkName() {
      this.societyConnector
        .checkDuplicate(10, this.currentSociety.account, 0)
        .then((isAvailable) => {
          this.nameAvailable = isAvailable;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    randomPass() {
      let charactersArray = this.characters.split(",");
      let characterSet = "";
      let password = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        characterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        characterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        characterSet += "0123456789";
      }
      if (charactersArray.indexOf("#") >= 0) {
        characterSet += "!%&*$#@";
      }

      for (let i = 0; i < this.size; i++) {
        password += characterSet.charAt(Math.floor(Math.random() * characterSet.length));
      }
      this.currentSociety.password = password;
    },
    copy() {
      // Only work in https
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.currentSociety.password).then(() => {
          //
        });
      } else {
        const dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.setAttribute("value", this.currentSociety.password);
        dummy.select();
        document.execCommand("copy");
        dummy.remove();
      }
    },
    setDefaultAccess() {
      // Complete access with defaults
      this.currentSociety.access = {
        name: this.$t("akito.admin"),
        permissions: "1|2|3|4|5|6|7|8|9",
      };
    },
    createSociety() {
      // Prevent double click on create
      this.disableButton = true;

      // Confirm last check of name available
      if (this.nameAvailable) {
        this.setDefaultAccess();

        // Insert society in DB
        this.societyConnector
          .insertSoc(this.currentSociety)
          .then(() => {
            // Empty the password to prevent double click
            this.currentSociety.password = "";
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            // Permit to reenable create button
            this.disableButton = false;
          });
      }
    },
    autoComplete() {
      // TODO: Do it better
      let login = this.currentSociety.account;
      login = login.split("'").join("");
      login = login.split('"').join("");
      login = login.split("-").join("");
      login = login.split(" ").join("");

      this.randomPass();

      // TODO: Check if login duplicate !!!
      this.currentSociety.login = "admin@" + login.toLowerCase() + ".fr";
      this.currentSociety.phone = "05 46 52 52 52";

      this.copy();
    },
  },
};
</script>

<style></style>
